// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { useModalContext } from 'components/ModalContext'
import React, { useCallback, useEffect } from 'react'
import { arrayOf, number } from 'prop-types'
import { useDispatch } from 'react-redux'
import { useBooleanToggle } from 'hooks'
import Form from './Form'
import { LoadingIcon } from 'components'

import {
  createNewProject,
  getInitialValues,
} from './helpers'

const ProjectCreate = props => {
  const {
    pathIds = [],
    projectIds = [],
  } = props

  const dispatch = useDispatch()

  const { closeContextModal } = useModalContext()

  const [isLoading, toggleIsLoading] = useBooleanToggle(true)

  const handleSubmit = useCallback((...args) => (
    dispatch(createNewProject(...args))
  ), [])

  useEffect(() => {
    (async () => {
      await dispatch(getInitialValues({ pathIds, projectIds }))
      toggleIsLoading()
    })()
  }, [])

  return (
    isLoading
      ? <LoadingIcon loading={true} />
      : (
        <Form
          closeContextModal={closeContextModal}
          onSubmit={handleSubmit} />
      )
  )
}

ProjectCreate.propTypes = {
  pathIds: arrayOf(number),
  projectIds: arrayOf(number),
}

export default ProjectCreate
